import { authQueryOptions, useAuthQuery } from "./use-auth-query";
import { client } from "@/api/client";
import { useQueryClient } from "@tanstack/react-query";

type AuthStatus = "pending" | "authenticated" | "unauthenticated";

export type AuthData = {
  status: AuthStatus;
  username: string | null;
  login: ({
    username,
    password,
  }: {
    username: string;
    password: string;
  }) => Promise<boolean>;
  logout: () => Promise<boolean>;
  ensureData: () => Promise<boolean>;
};

export const useAuth = (): AuthData => {
  const authQuery = useAuthQuery();
  const queryClient = useQueryClient();

  return {
    login: async ({ username, password }: { username: string; password: string }) => {
      try {
        const response = await client.auth.login.$post({
          json: {
            username,
            password,
          },
        });
        if (response.status === 200) {
          queryClient.setQueryData(["auth"], username);
          return true;
        }

        return false;
      } catch (error) {
        return false;
      }
    },
    logout: async () => {
      try {
        await client.auth.logout.$post();
      } catch (_) {}
      queryClient.setQueryData(["auth"], null);
      return true;
    },
    ensureData: async () => {
      return queryClient.ensureQueryData(authQueryOptions());
    },
    status: authQuery.isLoading ? "pending" : (authQuery.data ?? null) ? "authenticated" : "unauthenticated",
    username: authQuery.data ?? null,
  }

}